import Swal from 'sweetalert2'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { SerializedError } from '@reduxjs/toolkit'

/**
 *  @description SweetAler que dispara un error de consulta o guardado.
 *
 * @author andres.martinez, Hábil MX
 * @version 1.0.0, 08/05/2023
 *
 * @param isModoEditar Si es para un metodo de guardar o de actualizar
 * @param reintentar función para ejecutar al presionar sobre el botón 'reintentar'
 * @param errorActualizar Error que proviene del hook de actualizado
 * @param errorGuardar Error que proviene del hook de guardado
 */
export const alertUsuarios = (
  isModoEditar: boolean,
  reintentar: Function,
  errorActualizar: FetchBaseQueryError | SerializedError | undefined,
  errorGuardar: FetchBaseQueryError | SerializedError | undefined = errorActualizar
) => {
  const err:any = isModoEditar ? errorActualizar : errorGuardar
  const mensaje = err.data ? err.data.moreInfo : err.error ? err.error : ''
  Swal.fire({
    title: 'Algo salió mal',
    icon: 'error',
    html: `Por favor valida la información o intentalo mas tarde <br/><p class='mt-5 fs-7'>(${err.status}) ${mensaje}</p>`,
    showCancelButton: true,
    confirmButtonText: 'Intentar de nuevo',
    cancelButtonText: 'Cancelar',
    allowOutsideClick: true,
    allowEscapeKey: true,
  }).then((result) => {
    if (result.isConfirmed) {
      reintentar()
    }
  })
}
